import { FC, useState, useEffect, useRef } from 'react';
import Link from 'next/link';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { BTN_AUDIO_LFROM, DEV_ABSOLUTE_URL } from '@/helpers/variables';
import styles from '../litres-audio-player/LitresAudioPlayer.module.scss';

interface ILitresAudioPlayer {
  externalId: number;
}

const LitresAudioPlayer: FC<ILitresAudioPlayer> = ({ externalId }) => {
  const FAKE_TRACKS = [
    { name: '01.mp3', duration: '25:10' },
    { name: '02.mp3', duration: '20:50' },
    { name: '03.mp3', duration: '14:00' },
  ];

  const [isClient, setIsClient] = useState(false);
  const [noteShow, setNoteShow] = useState(false);

  const refTracks = useRef<HTMLDivElement>(null);

  const toggleActiveHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    const toggleBtn = e.currentTarget.parentElement;
    if (toggleBtn) {
      toggleBtn.dataset.accordion === 'closed' ? (toggleBtn.dataset.accordion = 'open') : (toggleBtn.dataset.accordion = 'closed');
      if (noteShow) {
        setNoteShow(false);
      }
    }
  };

  useEffect(() => {
    setIsClient(true);

    const handleClickOutside = (event: Event) => {
      if (refTracks.current && refTracks.current.contains(event.target as HTMLElement)) {
        return;
      }
      setNoteShow(false);
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  });

  return (
    <div id="audio_player" className={styles.audioPlayer}>
      {/* <audio className={styles.audioPlayer} src={`/trial/mp3/${externalId}.mp3`} controls={true} preload="none"></audio> */}
      {isClient && <AudioPlayer src={`${DEV_ABSOLUTE_URL}/trial/mp3/${externalId}.mp3`} defaultCurrentTime="00:00" volume={0.5} />}

      <div className={styles.audioPlayer__block} data-accordion="closed">
        <div className={styles.audioPlayer__button} onClick={toggleActiveHandler}>
          <span className={styles.audioPlayer__title}>Sample.mp3</span>
        </div>
        <div className={styles.audioPlayer__content} ref={refTracks}>
          <div className={styles.audioPlayer__contentWrap} onClick={() => setNoteShow(true)}>
            <ul className={styles.audioPlayer__tracks}>
              {FAKE_TRACKS.map((item) => (
                <li key={item.name} className={styles.audioPlayer__tracksItem}>
                  <span className={styles.audioPlayer__track}>{item.name}</span>
                  <span className={styles.audioPlayer__time}>{item.duration}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className={noteShow ? `${styles.audioPlayer__hidden} ${styles.audioPlayer__hidden_show}` : `${styles.audioPlayer__hidden}`}>
            <div className={styles.audioPlayer__hiddenTxt}>Для продолжения необходимо купить&nbsp;аудиокнигу</div>
            <Link prefetch={false} className="btnSmall" href={`https://www.litres.ru/pages/biblio_book/?art=${externalId}&lfrom=${BTN_AUDIO_LFROM}`} target="_blank">
              Купить и скачать
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LitresAudioPlayer;
